export class UserModel {
  userId!: number;
  displayName!: string;
  phone!: string;
  lastLogInDateTime!: Date;
  registerDateTime!: Date;
  pictureUrl!: string;
  signatureUrl!: string;
}

export class UserInfoModel {
  email!: string;
  firstName!: string;
  lastName!: string;
  phoneNumber!: string;
  signatureUrl!: string;
  userId!: number;

  constructor() {
    this.email = "";
    this.firstName = "";
    this.lastName = "";
    this.phoneNumber = "";
    this.signatureUrl = "";
    this.userId = 0;
  }
}
